module.exports = "https://cdn-skillquest.mathletics.com/app/174/assets/images/4e0e3cfc6afc1df2eb730b2abfa4b0a4.svg";